import { useEtapaObra } from "./use-etapa-obra";
import { EtapaObraView } from "./view-etapa-obra";

export function EtapaObra() {
  const vm = useEtapaObra();

  return <EtapaObraView {...vm} />;
}

export type * from "./types-etapa-obra";
